import React from 'react';
import { Button as ChakraButton, ButtonProps, Icon, Spinner } from '@chakra-ui/react';

interface CustomButtonProps extends Omit<ButtonProps, 'leftIcon'> {
  variant?: 'withBackground' | 'withoutBackground' | 'withBorder' | 'withDisabled';
  leftIcon?: React.ElementType;
  isLoading?: boolean;
}

export const ButtonCustom: React.FC<CustomButtonProps> = ({
  variant,
  leftIcon,
  children,
  isLoading,
  ...rest
}) => {
  let buttonStyles = {};
  let hoverStyles = {};
  let activeStyles = {};

  switch (variant) {
    case 'withBackground':
      buttonStyles = {
        bg: '#000',
        color: '#fff',
      };
      hoverStyles = {
        opacity: 0.8,
      };
      activeStyles = {
        opacity: 0.9,
      };
      break;
    case 'withoutBackground':
      buttonStyles = {
        color: '#595959',
        bg: 'transparent',
        border: 'none',
      };
      hoverStyles = {
        opacity: 0.9,
      };
      activeStyles = {
        opacity: 0.6,
      };
      break;
    case 'withBorder':
      buttonStyles = {
        color: '#344054',
        borderColor: '#2D3748',
        borderWidth: '1px',
        bg: 'transparent',
      };
      hoverStyles = {
        borderColor: '#344054',
        borderWidth: '1px',
        opacity: 0.9,
      };
      activeStyles = {
        opacity: 0.6,
      };
      break;
    case 'withDisabled':
      buttonStyles = {
        bg: '#EDEDED',
        color: '#7B7B7B',
      };
      hoverStyles = {};
      activeStyles = {};
      break;
    default:
      buttonStyles = {};
  }

  return (
    <ChakraButton
      {...buttonStyles}
      {...rest}
      isLoading={isLoading}
      spinner={<Spinner color="white" />}
      _hover={!rest.disabled ? hoverStyles : undefined}
      _active={!rest.disabled ? activeStyles : undefined}
      leftIcon={leftIcon ? <Icon as={leftIcon} /> : undefined}
      isDisabled={isLoading || rest.disabled}
      pointerEvents={rest.disabled ? 'none' : undefined}
      cursor={rest.disabled ? 'not-allowed' : undefined}
    >
      {isLoading ? null : children}
    </ChakraButton>
  );
};
